// Tek yardımcı fonksiyon — WhatsApp mesaj bağlantısı üretir.
// Numara: boşluk / artı / ülke kodundan sonra fazladan sıfır İÇERMEZ.
import { contact } from "@/config/site";

export function getWhatsAppUrl(message: string): string {
  return "https://wa.me/" + contact.whatsappNumber + "?text=" + encodeURIComponent(message);
}

// Hazır mesaj şablonları.
export const waMessages = {
  serviceInfo: (name: string) =>
    `Merhaba gülaYonar, web sitenizdeki ${name} hizmetini inceledim. İşlem içeriği ve güncel fiyatı hakkında bilgi almak istiyorum.`,
  serviceAppointment: (name: string) =>
    `Merhaba gülaYonar, ${name} için randevu talebimi iletmek istiyorum. Uygun gün ve saatler hakkında bilgi verebilir misiniz?`,
  general:
    "Merhaba gülaYonar, web sitenizden ulaşıyorum. Hizmetleriniz hakkında görüşmek ve randevu talebimi iletmek istiyorum.",
  bridal:
    "Merhaba gülaYonar, gelin saçı ve özel gün hazırlığı hizmetleriniz hakkında bilgi almak istiyorum. Detayları görüşebilir miyiz?",
  campaign:
    "Merhaba gülaYonar, web sitenizde Eylül 2026 cilt bakımı kampanyanızı gördüm. %25 indirimli bakımın kapsamını ve güncel ücretini öğrenmek istiyorum.",
  campaignAfter:
    "Merhaba gülaYonar, güncel cilt bakımı fırsatlarınız hakkında bilgi almak istiyorum.",
  location:
    "Merhaba gülaYonar, Odunluk'taki salonunuza gelmek istiyorum. Konum ve ulaşım bilgisi paylaşabilir misiniz?",
  generalQuestions:
    "Merhaba gülaYonar, web sitenizden ulaşıyorum. Hizmetleriniz hakkında birkaç sorum var.",
  hairVideo:
    "Merhaba gülaYonar, web sitenizdeki saç dönüşümü videosunu izledim. Saç tasarımı ve renklendirme hakkında bilgi almak istiyorum.",
  g5Video:
    "Merhaba gülaYonar, web sitenizdeki G5 bakımı videosunu izledim. G5 masajı hakkında bilgi almak istiyorum.",
};

// İleride Meta Pixel / analiz entegrasyonu için isteğe bağlı tıklama callback'i.
// service_id, source_section, page_path alanlarını taşır; takip betiği yapılandırılmadan yüklenmez.
export type WhatsAppClickPayload = {
  service_id?: string;
  source_section: string;
  page_path: string;
};

let clickTracker: ((payload: WhatsAppClickPayload) => void) | null = null;

export function setWhatsAppClickTracker(cb: ((payload: WhatsAppClickPayload) => void) | null) {
  clickTracker = cb;
}

export function trackWhatsAppClick(payload: WhatsAppClickPayload) {
  if (clickTracker) {
    clickTracker(payload);
  }
}